import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import TokenService from "src/Services/API/token.service";

let woNotesSocket;

const getWONotesSocket = () => {
  if (!woNotesSocket) {
    woNotesSocket = io(API_URL, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }

  return woNotesSocket;
};

const connectWONotesSocket = () => {
  const socket = getWONotesSocket();
  socket.auth = {
    token: TokenService.getLocalAccessToken(),
  };

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};

const disconnectWONotesSocket = () => {
  if (woNotesSocket?.connected) {
    woNotesSocket.disconnect();
  }
};

export { getWONotesSocket, connectWONotesSocket, disconnectWONotesSocket };
